(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uf-announcement"] && !Shopify.designMode) return;
  try {
    
(function () {
  var roots = document.querySelectorAll('[data-ufann]');
  roots.forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ufann-slide]'));
    if (slides.length < 2) return;

    var prevBtn = root.querySelector('[data-ufann-prev]');
    var nextBtn = root.querySelector('[data-ufann-next]');
    var index = 0;
    var timer = null;

    var auto = root.getAttribute('data-ufann-autorotate') === 'true';
    var speed = parseInt(root.getAttribute('data-ufann-speed'), 10) || 4000;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        if (n === index) { s.removeAttribute('hidden'); }
        else { s.setAttribute('hidden', ''); }
      });
    }
    function next() { show(index + 1); }
    function prev() { show(index - 1); }

    function start() {
      if (!auto || reduce) return;
      stop();
      timer = window.setInterval(next, speed);
    }
    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); start(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); start(); });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    show(0);
    start();
  });
})();

/* Copiar código al portapapeles (listener aparte; no toca la rotación) */
(function () {
  var COPIED_MS = 1600;

  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '-9999px';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    document.body.removeChild(ta);
    return ok;
  }

  function feedback(btn) {
    if (btn.__ufannTimer) { window.clearTimeout(btn.__ufannTimer); }
    var label = btn.querySelector('.ufann__copylabel');
    if (label) {
      if (!btn.__ufannLabel) { btn.__ufannLabel = label.textContent; }
      label.textContent = 'Copiado ✓';
    }
    btn.classList.add('is-copied');

    var root = btn.closest('[data-ufann]');
    var live = root && root.querySelector('[data-ufann-copyfeedback]');
    if (live) {
      var codeEl = btn.querySelector('.ufann__code');
      var codeTxt = codeEl ? codeEl.textContent : '';
      live.textContent = 'Código ' + codeTxt + ' copiado';
    }

    btn.__ufannTimer = window.setTimeout(function () {
      btn.classList.remove('is-copied');
      if (label && btn.__ufannLabel) { label.textContent = btn.__ufannLabel; }
      if (live) { live.textContent = ''; }
      btn.__ufannTimer = null;
    }, COPIED_MS);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-ufann-copy]') : null;
    if (!btn) return;
    e.preventDefault();
    var code = btn.getAttribute('data-ufann-copy') || '';
    if (!code) return;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function () {
        feedback(btn);
      }, function () {
        if (fallbackCopy(code)) { feedback(btn); }
      });
    } else if (fallbackCopy(code)) {
      feedback(btn);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uf-featured"] && !Shopify.designMode) return;
  try {
    
/* Slider de categorías — progressive enhancement (sin librería externa).
   El track ya desliza con scroll-snap nativo; el JS solo añade flechas que
   aparecen cuando hay overflow y se ocultan en los extremos. Sin JS => slider
   sigue funcionando por scroll/drag/táctil. */
(function () {
  function initSlider(slider) {
    if (slider.dataset.uffReady) return;
    slider.dataset.uffReady = '1';
    var track = slider.querySelector('[data-uff-track]');
    var prev = slider.querySelector('[data-uff-prev]');
    var next = slider.querySelector('[data-uff-next]');
    if (!track || !prev || !next) return;

    function scrollAmount() {
      var first = track.querySelector('.uff__li');
      var step = first ? first.getBoundingClientRect().width + 12 : track.clientWidth * 0.8;
      return Math.max(step, track.clientWidth * 0.8);
    }
    function update() {
      var overflow = track.scrollWidth - track.clientWidth > 4;
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft >= (track.scrollWidth - track.clientWidth - 2);
      prev.hidden = !overflow || atStart;
      next.hidden = !overflow || atEnd;
    }
    prev.addEventListener('click', function () {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll() {
    var sliders = document.querySelectorAll('[data-uff-slider]');
    for (var i = 0; i < sliders.length; i++) initSlider(sliders[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Re-inicializa al insertar/recargar la sección en el editor de temas.
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uf-paths"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-ufp-oem]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var input = form.querySelector('input[name="q"]');
      if (!input) return;
      // Normaliza el N° OEM: quita guiones/espacios para mitigar el bug del guion en S&D.
      var raw = (input.value || '').trim();
      var norm = raw.replace(/[\s\-\.]/g, '');
      if (norm) input.value = norm;
    });
  });
  document.querySelectorAll('[data-ufp-textsearch]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      // Enfoca el buscador predictivo nativo del header (Dawn).
      var sel = '#Search-In-Modal, predictive-search input[type="search"], details-modal input[type="search"], .search__input, input[name="q"][type="search"]';
      var input = document.querySelector(sel);
      var toggle = document.querySelector('summary[aria-haspopup="dialog"], .header__search summary, button[aria-label*="earch"], a[href="/search"]');
      if (input && input.offsetParent !== null) { input.focus(); input.select && input.select(); return; }
      if (toggle) { toggle.click(); setTimeout(function () {
        var i = document.querySelector(sel);
        if (i) { i.focus(); i.select && i.select(); }
      }, 120); return; }
      window.location.href = '/search';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uf-promo-strip"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-ufps-copy]').forEach(function (btn) {
    var label = btn.querySelector('.ufps__copy-label');
    var original = label ? label.textContent : '';
    btn.addEventListener('click', function () {
      var code = btn.getAttribute('data-ufps-copy') || '';
      var done = function () {
        btn.classList.add('is-copied');
        if (label) label.textContent = '¡Copiado!';
        setTimeout(function () {
          btn.classList.remove('is-copied');
          if (label) label.textContent = original;
        }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(function () {});
      } else {
        var ta = document.createElement('textarea');
        ta.value = code; ta.setAttribute('readonly', '');
        ta.style.position = 'absolute'; ta.style.left = '-9999px';
        document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); done(); } catch (e) {}
        document.body.removeChild(ta);
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
